"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pricingEstimateConf = void 0;
var constants_1 = require("containers/TableMaker/constants");
var utils_1 = require("../utils");
var ListPrice_1 = __importDefault(require("./CellComponents/ListPrice"));
var QuoteBenchmarkBar_1 = __importDefault(require("./CellComponents/QuoteBenchmarkBar"));
var VendorsOffer_1 = __importDefault(require("./CellComponents/VendorsOffer"));
var XL = constants_1.CellSize.XL, MD = constants_1.CellSize.MD, SM = constants_1.CellSize.SM;
exports.pricingEstimateConf = {
    headersMap: {
        name: 'Plans',
        description: '',
        vendorQuote: "Vendor's Offer",
        billingCycle: '',
    },
    extractors: {
        description: function (item) { return item.description ? item.description.split(';').join('. ') : ''; },
        billingCycle: function (item) { return item.billingCycle
            ? "(Billed ".concat(utils_1.BILLING_FREQ_MAPPER[item.billingCycle.months || 0], ")") : '(One-time Fee)'; },
    },
    cells: [
        {
            cell: { width: XL, growCell: true }, truncate: {}, fields: ['name', 'description'],
        },
        {
            cell: { width: MD },
            money: { isRounded: true, currency: 'AUD' },
            fields: ['listPrice', 'billingCycle'],
            renderComponent: ListPrice_1.default, // TODO handle DoubleCell that has the money prop (remove renderComponent after)
        },
        {
            cell: { width: 140, textAlign: 'right' }, truncate: {}, field: 'vendorQuote', renderComponent: VendorsOffer_1.default,
        },
        { cell: { width: SM } },
        {
            cell: { width: 300, textAlign: 'center' }, truncate: {}, field: 'benchmarks', renderComponent: QuoteBenchmarkBar_1.default,
        },
    ],
};
